import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

type GeoBlockDialogProps = {
  open: boolean
  onRetry: () => void
}

export function GeoBlockDialog({ open, onRetry }: GeoBlockDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Region Unavailable</DialogTitle>
          <DialogDescription>
            Your IP address is based in the United States.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onRetry}>Retry</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
